const gradients = [
    'linear-gradient(180deg, #FFB88E 0%, #EA5753 100%)',
    'linear-gradient(180deg, #FFD78A 0%, #F4762D 100%)',
    'linear-gradient(180deg, #F7E335 0%, #EDA854 100%)',
    'linear-gradient(180deg, #81AAFF 0%, #2271ED 100%)',
    'linear-gradient(180deg, #9BB2E5 0%, #6D90B9 100%)',
    'linear-gradient(180deg, #5D88B5 0%, #2F5A88 100%)',
    'linear-gradient(180deg, #9BD46A 0%, #5DA92F 100%)',
    'linear-gradient(180deg, #4A9B7F 0%, #287057 100%)',
    'linear-gradient(180deg, #CC86FA 0%, #9D61C5 100%)',
    'linear-gradient(180deg, #C9BEE8 0%, #7887BC 100%)'
];

/**
 * Reutrns CSS gradient string, based on the given text;
 * @param {string} text Text to calculate gradient.
 * @returns
 */
function getGradientByText(text) {
    // Get the first 6 letters of the text
    const normalizedString = text.replace(/[^a-zA-Z0-9а-яА-Я]/gm, '').substring(0, 20).toLowerCase();
    const totalWeight = normalizedString.split('').reduce((prev, current) => {
        const result = prev += current.charCodeAt(0);

        return result;
    }, 0);
    const gradientId = Math.floor(totalWeight % 100 / 10);

    return gradients[gradientId];
};

export { getGradientByText };
